/* Product cards: the cart button opens a simple "Choose your size" popup.
   Clicking a size adds that variant to the cart. */
(() => {
  if (window.oxSizePopupReady) return;
  window.oxSizePopupReady = true;

  const cfg = window.oxSizePopup || {};
  const SIZE_NAMES = ['size', 'taglia'];
  const BTN = '.product-item__inner select-option.product-item__select-options, .ox-card-add';
  const cache = {};
  let overlay, panel, list, msg, lastFocus;

  function build() {
    if (overlay) return;
    overlay = document.createElement('div');
    overlay.className = 'ox-size-popup';
    overlay.hidden = true;
    overlay.innerHTML =
      '<div class="ox-size-popup__panel" role="dialog" aria-modal="true" aria-labelledby="ox-size-popup-title">' +
        '<div class="ox-size-popup__head">' +
          '<span id="ox-size-popup-title" class="ox-size-popup__title"></span>' +
          '<button type="button" class="ox-size-popup__close" aria-label="Close">' +
            '<svg width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M1 1l14 14M15 1L1 15" stroke="currentColor" stroke-width="1.5"/></svg>' +
          '</button>' +
        '</div>' +
        '<ul class="ox-size-popup__list"></ul>' +
        '<p class="ox-size-popup__msg" role="status"></p>' +
      '</div>';
    document.body.appendChild(overlay);
    panel = overlay.querySelector('.ox-size-popup__panel');
    list = overlay.querySelector('.ox-size-popup__list');
    msg = overlay.querySelector('.ox-size-popup__msg');
    overlay.querySelector('.ox-size-popup__title').textContent = cfg.heading || 'Choose your size';
    overlay.querySelector('.ox-size-popup__close').addEventListener('click', close);
    overlay.addEventListener('click', (e) => { if (e.target === overlay) close(); });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && !overlay.hidden) close(); });
  }

  function open() {
    build();
    lastFocus = document.activeElement;
    overlay.hidden = false;
    document.documentElement.classList.add('ox-size-popup-open');
    requestAnimationFrame(() => overlay.classList.add('is-open'));
  }

  function close() {
    if (!overlay || overlay.hidden) return;
    overlay.classList.remove('is-open');
    document.documentElement.classList.remove('ox-size-popup-open');
    setTimeout(() => { overlay.hidden = true; }, 200);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function setMsg(text, isError) {
    msg.textContent = text || '';
    msg.classList.toggle('is-error', !!isError);
  }

  function labelFor(product, variant) {
    const idx = product.options.findIndex((o) => {
      const name = (typeof o === 'string' ? o : o.name || '').toLowerCase().trim();
      return SIZE_NAMES.includes(name);
    });
    if (product.options.length === 1) return variant.option1;
    if (idx > -1) {
      const others = variant.options.filter((_, i) => i !== idx).join(' / ');
      return variant.options[idx] + (others ? ' · ' + others : '');
    }
    return variant.title;
  }

  function render(product) {
    list.innerHTML = '';
    /* Only show sizes that are in stock */
    const inStock = product.variants.filter((v) => v.available);
    if (!inStock.length) {
      setMsg(cfg.allSoldOut || 'Sorry, this product is sold out.', true);
      return;
    }
    inStock.forEach((variant) => {
      const li = document.createElement('li');
      const b = document.createElement('button');
      b.type = 'button';
      b.className = 'ox-size-popup__item';
      b.dataset.id = variant.id;
      const name = document.createElement('span');
      name.textContent = labelFor(product, variant);
      b.appendChild(name);
      b.addEventListener('click', () => add(variant.id, b));
      li.appendChild(b);
      list.appendChild(li);
    });
    const first = list.querySelector('button:not([disabled])');
    if (first) first.focus();
  }

  async function load(handle) {
    if (cache[handle]) return cache[handle];
    const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    const res = await fetch(root + 'products/' + handle + '.js', { headers: { Accept: 'application/json' } });
    if (!res.ok) throw new Error('load');
    cache[handle] = await res.json();
    return cache[handle];
  }

  function showAdded() {
    msg.textContent = '';
    msg.classList.remove('is-error');
    msg.appendChild(document.createTextNode((cfg.added || 'Added to cart') + ' '));
    const a = document.createElement('a');
    a.href = (window.routes && window.routes.cart_url) || '/cart';
    a.textContent = cfg.viewCart || 'View cart';
    a.className = 'ox-size-popup__viewcart';
    msg.appendChild(a);
  }

  /* Update the cart count bubble(s) in the header without reloading the page */
  async function updateCount() {
    try {
      const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      const res = await fetch(root + 'cart.js', { headers: { Accept: 'application/json' } });
      const cart = await res.json();
      const n = cart.item_count < 100 ? String(cart.item_count) : '~';
      document.querySelectorAll('.cart-count').forEach((el) => {
        if (el.classList.contains('cart-count-drawer')) {
          el.textContent = ' (' + cart.item_count + ') ';
          return;
        }
        /* Replace everything inside the bubble (header and mobile bar use
           different markup, e.g. <span>0</span> when the cart was empty) */
        el.textContent = n;
        const sr = document.createElement('span');
        sr.className = 'visually-hidden';
        sr.textContent = cart.item_count + ' items';
        el.appendChild(sr);
      });
    } catch (e) { /* count will refresh on next page load */ }
  }

  async function add(id, btn) {
    list.querySelectorAll('button').forEach((x) => x.classList.remove('is-loading'));
    btn.classList.add('is-loading');
    setMsg('');
    try {
      const addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add';
      const res = await fetch(addUrl + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.description || data.message || 'error');
      btn.classList.remove('is-loading');
      btn.classList.add('is-added');
      showAdded();
      updateCount();
      document.dispatchEvent(new CustomEvent('ox:cart-updated', { detail: data }));
      setTimeout(close, 2500);
    } catch (err) {
      btn.classList.remove('is-loading');
      setMsg(err.message && err.message !== 'error' ? err.message : (cfg.error || 'Could not add to cart. Please try again.'), true);
    }
  }

  async function handle(btn) {
    const url = btn.dataset.url || '';
    const m = url.match(/\/products\/([^?#/]+)/);
    if (!m) return false;
    build();
    list.innerHTML = '<li class="ox-size-popup__loading">' + (cfg.loading || 'Loading…') + '</li>';
    setMsg('');
    open();
    try {
      render(await load(m[1]));
    } catch (e) {
      list.innerHTML = '';
      setMsg(cfg.error || 'Could not load sizes. Please try again.', true);
    }
    return true;
  }

  function intercept(e) {
    const btn = e.target.closest && e.target.closest(BTN);
    if (!btn) return;
    if (e.type === 'keydown' && e.key !== 'Enter' && e.key !== ' ') return;
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    handle(btn);
  }

  document.addEventListener('click', intercept, true);
  document.addEventListener('keydown', intercept, true);

  /* Add a "+" add-to-cart button to the right of the price on every product card */
  const PLUS_SVG =
    '<svg width="18" height="18" viewBox="0 0 18 18" fill="none" aria-hidden="true">' +
    '<path d="M9 2v14M2 9h14" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>';

  function decorate() {
    document.querySelectorAll('.product-item__information:not(.type-list) .product-item__price').forEach((price) => {
      if (price.querySelector('.ox-card-add')) return;
      const card = price.closest('.product-item');
      const link = card && card.querySelector('a.product-item__name[href*="/products/"], a[href*="/products/"]');
      if (!link) return;
      const path = new URL(link.getAttribute('href'), location.origin).pathname;
      const b = document.createElement('button');
      b.type = 'button';
      b.className = 'ox-card-add';
      b.dataset.url = path;
      b.setAttribute('aria-label', (cfg.addLabel || 'Add to cart') + ': ' + (link.textContent || '').trim());
      b.innerHTML = PLUS_SVG;
      price.appendChild(b);
    });
  }

  let queued = false;
  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; decorate(); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule);
  else schedule();
  /* Cards loaded later (sliders, infinite scroll, recommendations) */
  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
})();
